import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { last } from 'lodash-es';
import { hashCodeLib } from 'shared';

import { bookingStateModel } from '@/features/booking-state';

/** Direction / dates copy for `EmptyPage` (OW/RT vs multi-city from search hash). */
export function useProductsEmptyPageHeader() {
  const bookingStore = bookingStateModel.useBookingStore();
  const { mappedFlights, offer } = storeToRefs(bookingStore);

  const isMultiTripSearch = computed(() => {
    const query = offer.value?.$meta?.search_query;
    return typeof query === 'string' && hashCodeLib.isMultiTripSearch(query);
  });

  const directionText = computed(() => {
    const flights = mappedFlights.value;
    if (!flights.length) {
      return '';
    }
    const firstDep = flights[0].segments[0].dep;
    if (isMultiTripSearch.value) {
      const lastFlight = flights[flights.length - 1];
      const finalArr = last(lastFlight.segments)?.arr;
      return finalArr ? `${firstDep.city} - ${finalArr.city}` : firstDep.city;
    }
    const arrivalCity = last(flights[0].segments)?.arr.city;
    return `${firstDep.city} - ${arrivalCity}`;
  });

  const datesText = computed(() => {
    const flights = mappedFlights.value;
    if (!flights.length) {
      return '';
    }
    const firstDep = flights[0].segments[0].dep;
    if (isMultiTripSearch.value) {
      return flights.map(f => f.segments[0].dep.dayOfMonth).join(' - ');
    }
    const arrivalDate = last(last(flights)?.segments)?.dep.dayOfMonth;
    return `${firstDep.dayOfMonth} - ${arrivalDate}`;
  });

  return { directionText, datesText };
}
